export function isTemplate() {
  return window.location.href.includes('/wikis/templates/');
}
